import { Navigate, Route, Routes } from "react-router-dom";
import CreateBloggerPage from "../pages/CreateBloggerPage";
import BloggersPage from "../pages/BloggersPage";
import BloggersImportPage from "../pages/BloggersImportPage";
import UserPage from "../pages/UserPage";
import EditBloggerPage from "../pages/EditBloggerPage";
import SearchTasksPage from "../pages/SearchTasksPage";
import SearchTaskPage from "../pages/SearchTaskPage";
import NotificationsPage from "../pages/NotificationsPage";
import UsersPage from "../pages/UsersPage";
import AppBar from "../AppBar";
import { Box } from "@mui/material";
import { ReportPage } from "../components/ReportPage";
import { GrowthReportPage } from "../components/GrowthReportPage";
import { FollowUpReportPage } from "../components/FollowUpReportPage";
import PublicRelationsPage from "../pages/PublicRelationsPage";
import PublicRelationPage from "../pages/PublicRelationPage";
import PublicRelationEditPage from "../pages/PublicRelationEditPage";
import { TimesheetPage } from "../pages/TimesheetPage";
import { TimesheetSummaryPage } from "../pages/TimesheetSummaryPage";
import { TemplatesPage } from "../pages/TemplatesPage";
import { TemplatePage } from "../pages/TemplatePage";
import EmailAccounts from "../pages/EmailAccounts";
import CreateEmailAccountPage from "../pages/CreateEmailAccountPage";
import { EmailAccountPage } from "../pages/EmailAccountPage";
import PublicRelationsImportPage from "../pages/PublicRelationsImportPage";
import StudiosPage from "../pages/studios/StudiosPage";
import CreateStudioPage from "../pages/studios/CreateStudioPage";
import EditStudioPage from "../pages/studios/EditStudioPage";
import LeadsPage from "../pages/leads/LeadsPage";
import CreateLeadPage from "../pages/leads/CreateLeadPage";
import EditLeadPage from "../pages/leads/EditLeadPage";
import AiAgentsPage from "../pages/aiagents/AiAgentsPage";
import CreateAiAgentPage from "../pages/aiagents/CreateAiAgentPage";
import EditAiAgentPage from "../pages/aiagents/EditAiAgentPage";
import ImportPage from "../components/ImportPage";
import EmailSchedulersPage from "../pages/emailSchedulers/EmailSchedulersPage";
import CreateEmailSchedulerPage from "../pages/emailSchedulers/CreateEmailSchedulerPage";
import EditEmailSchedulerPage from "../pages/emailSchedulers/EditEmailSchedulerPage";
import SettingsPage from "../pages/settings/SettingsPage";

export const AdminView = () => (
  <>
  <AppBar pages={
    [
      {
        label: 'Bloggers',
        route: '/bloggers'
      },
      {
        label: 'Search tasks',
        route: '/search-tasks'
      },
      {
        label: 'PR',
        route: '/pr'
      },
      {
        label: 'Studios',
        route: '/studios'
      },
      {
        label: 'Leads',
        route: '/leads'
      },
      {
        label: 'AI Agents',
        route: '/aiagents'
      },
      {
        label: 'Users',
        route: '/users'
      },
      {
        label: 'Notifications',
        route: '/notifications'
      },
      {
        label: 'Templates',
        route: '/templates'
      },
      {
        label: 'Email Accounts',
        route: '/email-accounts'
      },
      {
        label: 'Timesheet',
        route: '/timesheet'
      },
      {
        label: 'Timesheet Summary',
        route: '/timesheet-summary'
      },
      {
        label: 'Email Schedulers',
        route: '/email-schedulers'
      },
      {
        label: 'Settings',
        route: '/settings'
      },
    ]
  }/>
  <Box sx={{ p: 3, flexGrow: 1, minHeight: 0, overflow: 'auto'}}>
    <Routes>
      <Route path="/users" element={<UsersPage/>}></Route>
      <Route path="/users/new" element={<UserPage />}></Route>
      <Route path="/users/:id" element={<UserPage />}></Route>
      
      <Route path="/" element={<Navigate to="/bloggers" />}></Route>
      
      <Route path="/bloggers" element={<BloggersPage/>}></Route>
      <Route path="/bloggers/import" element={<BloggersImportPage/>}></Route>
      <Route path="/bloggers/new" element={<CreateBloggerPage/>}></Route>
      <Route path="/bloggers/:id" element={<EditBloggerPage/>}></Route>
      
      <Route path="/search-tasks" element={<SearchTasksPage/>}></Route>
      <Route path="/search-tasks/new" element={<SearchTaskPage />}></Route>
      <Route path="/search-tasks/:id" element={<SearchTaskPage />}></Route>

      <Route path="/pr" element={<PublicRelationsPage/>}></Route>
      <Route path="/pr/new" element={<PublicRelationPage />}></Route>
      <Route path="/pr/:id" element={<PublicRelationEditPage />}></Route>
      <Route path="/pr/import" element={<PublicRelationsImportPage/>}></Route>
      <Route path="/notifications" element={<NotificationsPage/>}></Route>

      <Route path="/bloggers_report" element={
        <ReportPage
          statuses={['no answer', 'pending', 'affiliate']}
          eventName="Blogger.getReport"
        />
      }/>
      <Route path="/bloggers_growth_report" element={<GrowthReportPage/>}/>
      <Route path="/bloggers_follow_up_report" element={<FollowUpReportPage/>}/>
      <Route path="/pr_report" element={
        <ReportPage
          statuses={['no answer', 'pending', 'posted']}
          eventName="getPRReport"
        />
      }/>
      <Route path="/timesheet" element={<TimesheetPage/>}/>
      <Route path="/timesheet-summary" element={<TimesheetSummaryPage/>}/>

      <Route path="/templates" element={<TemplatesPage/>}></Route>
      <Route path="/templates/new" element={<TemplatePage/>}></Route>
      <Route path="/templates/:id" element={<TemplatePage/>}></Route>

      <Route path="/email-accounts" element={<EmailAccounts/>}></Route>
      <Route path="/email-accounts/new" element={<CreateEmailAccountPage/>}></Route>
      <Route path="/email-accounts/:id" element={<EmailAccountPage/>}></Route>

      <Route path="/studios" element={<StudiosPage/>}></Route>
      <Route path="/studios/new" element={<CreateStudioPage/>}></Route>
      <Route path="/studios/import" element={<ImportPage event="studios.importStudios"/>}></Route>
      <Route path="/studios/report" element={
        <ReportPage
          statuses={['no answer', 'pending', 'client']}
          eventName="studios.getReport"
        />
      }></Route>
      <Route path="/studios/:id" element={<EditStudioPage/>}></Route>

      <Route path="/leads" element={<LeadsPage/>}></Route>
      <Route path="/leads/new" element={<CreateLeadPage/>}></Route>
      <Route path="/leads/report" element={
        <ReportPage
          statuses={['no answer', 'pending', 'partner']}
          eventName="leads.getReport"
        />
      }></Route>
      <Route path="/leads/:id" element={<EditLeadPage/>}></Route>

      <Route path="/aiagents" element={<AiAgentsPage/>}></Route>
      <Route path="/aiagents/new" element={<CreateAiAgentPage/>}></Route>
      <Route path="/aiagents/:id" element={<EditAiAgentPage/>}></Route>

      <Route path="/email-schedulers" element={<EmailSchedulersPage/>}></Route>
      <Route path="/email-schedulers/new" element={<CreateEmailSchedulerPage/>}></Route>
      <Route path="/email-schedulers/:id" element={<EditEmailSchedulerPage/>}></Route>

      <Route path="/settings" element={<SettingsPage/>}></Route>
    </Routes>
  </Box>
  </>
)